import { activities } from "./activities"

export const odin = {
  activities,
}
